// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__mrBLC","title":"styles_title___62rQ","hasImage":"styles_hasImage__dfz8y","visible":"styles_visible__fhGXo","hasColor":"styles_hasColor__jOoMa"};